module.exports = __webpack_public_path__ + "img/school_group_sm.26da138f.jpg";